export const removeFirstAndLastQuotes = (str) => {
    var firstChar = str.charAt(0);
    var lastChar = str[str.length - 1];
    //double quotes
    if (firstChar && lastChar === String.fromCharCode(34)) {
      str = str.slice(1, -1);
    }
    //single quotes
    if (firstChar && lastChar === String.fromCharCode(39)) {
      str = str.slice(1, -1);
    }
    return str.toString();
  };